export default __webpack_public_path__ + "static/media/physiotherapist-and-boy-holding-ball-600x338.2b3a8bc5.png";